import { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { useStep } from '../hooks/useStep';
import { Title4 } from '../styles/TypoStyle';
import { Step } from '../utils/Steps';
import cLogo from './assets/cLogo.svg';
const Container = styled.div`
  display: flex;
  height: 60px;
`;
const HaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding-left: 8px;
  padding-right: 16px;
  img {
    cursor: pointer;
  }
`;

interface HeaderProps {
  currentStep: Step;
}
export const HeaderContainer: FunctionComponent<HeaderProps> = ({ currentStep }): ReactElement => {
  const { stepData } = useStep(currentStep);

  return (
    <Container>
      <HaderContainer>
        <img src={cLogo} />
        <Title4>{stepData?.family}</Title4>
      </HaderContainer>
    </Container>
  );
};
